angular.module("registrationModule").component("registrationPhoneRequest", {
	templateUrl: "registrationPhoneRequest/registrationPhoneRequest.html",
	bindings: {
		onValidatePhone: "&",
		onSubmit: "&",
		onClose: "&",
		user: "<",
		interest: "<",
		errorMessages: "<",
		adDesignVersion: "<",
		adDesignEnabled: "<",
		buildingRegion: "<",
		buildingNameOrAddress: "<",
		version: "<",
	},
	controller: ["$document", "$window", "$timeout", "$element", "$sce", function($document, $window, $timeout, $element, $sce) {
		var self = this;

		this.phoneBottomMessage = '';

		this.anArticle = "A";

		if (this.buildingRegion && this.buildingRegion.length > 0) {
			this.anArticle = ["a", "e", "i", "o", "u"].indexOf(this.buildingRegion.charAt(0).toLowerCase()) !== -1 ? "An" : "A";
		}

		this.submit = function() {
			if ((typeof this.form.phone !== "undefined") && !this.form.phone.$touched) {
				this.form.phone.$touched = true;
			}

			if (((typeof this.form.needsValidation !== "undefined") && this.form.needsValidation) || (typeof this.form.needsValidation === "undefined")) {
				this.validatePhone(this.user.phone, this.form, function () { self.submit() ;});
			} else if (this.form.$valid) {
				this.onSubmit({form: this.form});
			}
		};

		this.validatePhone = function(phone, form, callback) {
			this.onValidatePhone({phone: phone, form: form, callback: callback});
		};

		this.$onDestroy = function() {
			$document.off("click", self.closeHandler);
		};

		this.closeHandler = function(e) {
			if ($element !== e.target && !$element[0].contains(e.target)) {
				$timeout(function () { self.onClose();});
			}
		};

		this.close = function() {
			$timeout(function () { $window.location.reload(); });
		};

		this.fieldChange = function(key) {
			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};


		this.isBuyingSelected = function() {
			return this.adDesignEnabled === "1" && this.interest == "lookingToBuy";
		};

		this.isRentingSelected = function() {
			return this.adDesignEnabled === "1" && this.interest == "lookingToRent";
		};

		this.isSellingSelected = function() {
			return this.adDesignEnabled === "1" && this.interest == "lookingToSell";
		};

		this.isOtherSelected = function() {
			return this.adDesignEnabled === "1" && this.interest == "lookingToNeither";
		};

	}]
});